<template>
	<EMCoreTemplate category="OSMLife" identity="paymentHistory" entity="osm_payment_history"></EMCoreTemplate>
</template>
<script type="text/javascript">
	import {EMCoreTemplate} from '@/Adm/components' 
	export default{
		components:{
			EMCoreTemplate
		}	
	}

</script>


// WEBPACK FOOTER //
// src/Adm/EntityManagementLife/containers/PaymentHistory.vue